<template>
    <navbar :show-navbar="showNavbar">
        <div class="navbar-wrapper">
            <div class="navbar-minimize">
                <button id="minimizeSidebar" class="btn btn-icon" @click="minimizeSidebar">
                    <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
                    <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
                </button>
            </div>
            <div class="navbar-toggle">
                <navbar-toggle-button @click.native="toggleSidebar"> </navbar-toggle-button>
            </div>
            <router-link :to="{ path: '/portal/dashboard' }" class="navbar-brand">Verda Support</router-link>
        </div>
        <div class="navbar-toggle">
            <span>
                <router-link :to="{ path: '/portal/account' }" class="nav-link">
                    <i class="fa fa-user-circle"></i>
                </router-link>
            </span>
            <a
                class="nav-link"
                @click="
                    minimizeSidebar()
                    logout()
                "
            >
                <p>
                    <span class="d-md-block">Sign out</span>
                </p>
            </a>
        </div>
        <template slot="navbar-menu">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link :to="{ path: '/portal/account' }" class="nav-link">
                        <i class="fa fa-user-circle"></i>
                    </router-link>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        @click="
                            minimizeSidebar()
                            logout()
                        "
                    >
                        <p>
                            <span class="d-md-block">Sign out</span>
                        </p>
                    </a>
                </li>
            </ul>
        </template>
    </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from '@/components/UIComponents'

export default {
    components: {
        Navbar,
        NavbarToggleButton
    },
    data() {
        return {
            activeNotifications: false,
            showNavbar: false
        }
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown() {
            this.activeNotifications = false
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false)
        },
        minimizeSidebar() {
            this.$sidebar.toggleMinimize()
        },
        toggleNavbar() {
            this.showNavbar = !this.showNavbar
        },
        async logout() {
            await this.$store.dispatch('auth/LOGOUT')
            this.$router.replace('/')
        }
    }
}
</script>
<style>
a:hover {
    cursor: pointer;
}
</style>
